import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import SelectDropdown from "../../../components-react/SelectDropdown";
import {
  generatePlanDuration1,
  HHMMSS,
  setTypes,
} from "../../../common-data/DropdowData";
import {
  fetchWorkoutCategoriesData,
  fetchWorkoutExerciseDropdown,
} from "../../../../redux/workout-reducers/workoutApis";
// import SelectDropdownDynamic from "../../../components-react/SelectDropdownDynamic";
import SelectDropdownLabel from "../../../components-react/SelectDropdownLabel";
import { fetchApiData } from "../../../../redux/reducers/commonApiSlice";
import { workoutExercisesGet } from "../../../../data/ApiEndpoints";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import Loader from "../../../ui/Loader";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { toast } from "react-toastify";
import { BodyBuilder } from "../../../../exports/Images";
import ExerciseAddForm from "../../exercise/ExerciseAddForm";

const WorkoutDays = ({
  userInfoData,
  exerciseDays,
  setExerciseDays,
  setIsSubmit,
  formErrors,
  dayIndex,
  exerciseDaysArray,
  isViewOnly,
}) => {
  const dispatch = useDispatch();
  const { exerciseDropdownData, workoutCategoriesData } = useSelector(
    (state) => state.workoutApi
  );
  const { data, loading } = useSelector((state) => state.common);

  const iniValues = {
    status: "active",
    limit: 1000,
    page: 1,
    search: "",
  };
  const [fetchValues, setFetchValues] = useState(iniValues);
  const [totalPages, setTotalPages] = useState(1);
  const [selTempCat, setSelTempCat] = useState("");
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    exerciseId: "",
    rowData: "",
    rowDataEdit: "",
    viewVideo: "",
    viewImage: "",
    alternate: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [workoutDaysDropdown, setWorkoutDaysDropdown] = useState([]);
  const [selectedCopyFrom, setSelectedCopyFrom] = useState("");

  const EXERCISE_DAYS_ARRAY_LENGTH = exerciseDaysArray?.length || 0;

  const onChangeInput = (e, dayIndex, exerciseIndex, setIndex) => {
    setIsSubmit(false);

    const { name, value } = e.target;
    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) =>
        dIndex === dayIndex
          ? {
              ...day,
              allSetTypes: day.allSetTypes.map((setType) => ({
                ...setType,
                allExercises: setType.allExercises.map((exercise, eIndex) =>
                  eIndex === exerciseIndex
                    ? {
                        ...exercise,
                        allSets: (exercise.allSets || []).map((set, sIndex) =>
                          sIndex === setIndex ? { ...set, [name]: value } : set
                        ),
                      }
                    : exercise
                ),
              })),
            }
          : day
      )
    );
  };

  const onChangeExerciseInput = (e, dayIndex, setTypeIndex, exerciseIndex) => {
    setIsSubmit(false);

    const { name, value } = e.target;
    const numericValue =
      name === "restTime" ? parseInt(value, 10) || "" : value;

    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) =>
        dIndex === dayIndex
          ? {
              ...day,
              allSetTypes: day.allSetTypes.map((setType, stIndex) =>
                stIndex === setTypeIndex
                  ? {
                      ...setType,
                      allExercises: setType.allExercises.map(
                        (exercise, eIndex) =>
                          eIndex === exerciseIndex
                            ? { ...exercise, [name]: numericValue }
                            : exercise
                      ),
                    }
                  : setType
              ),
            }
          : day
      )
    );
  };

  const onChangeDropdownSetType = (
    selectedOption,
    name,
    dayIndex,
    setTypeIndex
  ) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) => {
        if (dIndex === dayIndex) {
          const updatedSetTypes = day.allSetTypes.map((setType, sIndex) => {
            if (sIndex === setTypeIndex) {
              let updatedExercises = setType.allExercises.map(
                (exercise, eIndex) => ({
                  ...exercise,
                  exerciseId:
                    selectedOption?.value === "superset"
                      ? `${eIndex + 1}${String.fromCharCode(97 + eIndex)}`
                      : `${eIndex + 1}`,
                })
              );

              if (
                selectedOption?.value === "superset" &&
                setType.allExercises.length < 2
              ) {
                updatedExercises.push({
                  exerciseId: `${
                    setType.allExercises.length + 1
                  }${String.fromCharCode(97 + setType.allExercises.length)}`,
                  selExerciseName: "",
                  restTime: "",
                  sequenceNo: "",
                  allSets: [
                    {
                      setId: 1,
                      weight: "",
                      selTentativeDurationHH: "",
                      selTentativeDurationMM: "",
                      selTentativeDurationSS: "",
                      reps: "",
                    },
                  ],
                });
              }

              if (selectedOption?.value === "singular") {
                updatedExercises = updatedExercises.slice(0, 1);
              }

              return {
                ...setType,
                [name]: selectedOption,
                allExercises: updatedExercises,
              };
            }
            return setType;
          });

          return {
            ...day,
            allSetTypes: updatedSetTypes,
          };
        }
        return day;
      })
    );
  };

  const onChangeDropdownExerciseName = (
    value,
    name,
    dayIndex,
    setTypeIndex,
    exerciseIndex
  ) => {
    setIsSubmit(false);

    if (name === "selCategoryName") {
      setSelTempCat(value?.value || "");
    }

    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) =>
        dIndex === dayIndex
          ? {
              ...day,
              allSetTypes: day.allSetTypes.map((setType, stIndex) =>
                stIndex === setTypeIndex
                  ? {
                      ...setType,
                      allExercises: setType.allExercises.map(
                        (exercise, eIndex) =>
                          eIndex === exerciseIndex
                            ? {
                                ...exercise,
                                [name]: value,
                                ...(name === "selCategoryName" && {
                                  selExerciseName: "",
                                  allSets: [
                                    {
                                      setId: 1,
                                      weight: "",
                                      selTentativeDurationHH: "",
                                      selTentativeDurationMM: "",
                                      selTentativeDurationSS: "",
                                      reps: "",
                                    },
                                  ],
                                }),
                              }
                            : exercise
                      ),
                    }
                  : setType
              ),
            }
          : day
      )
    );

    // setExerciseDays((prevDays) =>
    //   prevDays.map((day, dIndex) =>
    //     dIndex === dayIndex
    //       ? {
    //           ...day,
    //           allSetTypes: day.allSetTypes.map((setType, stIndex) =>
    //             stIndex === setTypeIndex
    //               ? {
    //                   ...setType,
    //                   allExercises: setType.allExercises.map(
    //                     (exercise, eIndex) =>
    //                       eIndex === exerciseIndex
    //                         ? { ...exercise, [name]: value }
    //                         : exercise
    //                   ),
    //                 }
    //               : setType
    //           ),
    //         }
    //       : day
    //   )
    // );
  };

  const onChangeDuration = (
    selectedOption,
    name,
    dayIndex,
    exerciseIndex,
    setIndex,
    setTypeIndex
  ) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) =>
        dIndex === dayIndex
          ? {
              ...day,
              allSetTypes: day.allSetTypes.map((setType, stIndex) =>
                stIndex === setTypeIndex
                  ? {
                      ...setType,
                      allExercises: setType.allExercises.map(
                        (exercise, eIndex) =>
                          eIndex === exerciseIndex
                            ? {
                                ...exercise,
                                allSets: exercise.allSets.map((set, sIndex) =>
                                  sIndex === setIndex
                                    ? { ...set, [name]: selectedOption }
                                    : set
                                ),
                              }
                            : exercise
                      ),
                    }
                  : setType
              ),
            }
          : day
      )
    );
  };

  // ADDING
  const addNewExercise = (dayIndex, setTypeIndex) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) =>
        dIndex === dayIndex
          ? {
              ...day,
              allSetTypes: day.allSetTypes.map((setType, stIndex) =>
                stIndex === setTypeIndex
                  ? {
                      ...setType,
                      allExercises: [
                        ...setType.allExercises,
                        {
                          exerciseId:
                            setType.selSetType?.value === "superset"
                              ? `${
                                  setType.allExercises.length + 1
                                }${String.fromCharCode(
                                  97 + setType.allExercises.length
                                )}`
                              : `${setType.allExercises.length + 1}`,
                          selExerciseName: "",
                          restTime: "",
                          sequenceNo: "",
                          allSets: [
                            {
                              setId: 1,
                              weight: "",
                              selTentativeDurationHH: "",
                              selTentativeDurationMM: "",
                              selTentativeDurationSS: "",
                              reps: "",
                            },
                          ],
                        },
                      ],
                    }
                  : setType
              ),
            }
          : day
      )
    );
  };

  const addMoreSet = (dayIndex, exerciseIndex) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) =>
        dIndex === dayIndex
          ? {
              ...day,
              allSetTypes: day.allSetTypes.map((setType) => ({
                ...setType,
                allExercises: setType.allExercises.map((exercise, eIndex) =>
                  eIndex === exerciseIndex
                    ? {
                        ...exercise,
                        allSets: [
                          ...exercise.allSets,
                          {
                            setId: exercise.allSets.length + 1, // Incremental ID for new set
                            weight: "",
                            selTentativeDurationHH: "",
                            selTentativeDurationMM: "",
                            selTentativeDurationSS: "",
                            reps: "",
                          },
                        ],
                      }
                    : exercise
                ),
              })),
            }
          : day
      )
    );
  };

  const handleAddSetType = (dayIndex) => {
    setExerciseDays((prevDays) => {
      const updatedExerciseDays = prevDays.map((day, index) => {
        if (day.day === dayIndex) {
          const updatedSetTypes = day.allSetTypes ? [...day.allSetTypes] : [];

          const newSetType = {
            selSetType: "",
            allExercises: [
              {
                exerciseId: "1",
                selCategoryName: "",
                selExerciseName: "",
                restTime: "",
                sequenceNo: "",
                allSets: [
                  {
                    setId: 1,
                    weight: "",
                    selTentativeDurationHH: "",
                    selTentativeDurationMM: "",
                    selTentativeDurationSS: "",
                    reps: "",
                  },
                ],
              },
            ],
          };

          updatedSetTypes.push(newSetType);

          return {
            ...day,
            allSetTypes: updatedSetTypes,
          };
        }

        return day;
      });

      return updatedExerciseDays;
    });
  };
  // ---------------- ADDING -------------------

  // REMOVING
  const removeExercise = (dayIndex, setTypeIndex, exerciseIndex) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) =>
        dIndex === dayIndex
          ? {
              ...day,
              allSetTypes: day.allSetTypes.map((setType, stIndex) =>
                stIndex === setTypeIndex
                  ? {
                      ...setType,
                      allExercises: setType.allExercises.filter(
                        (_, eIndex) => eIndex !== exerciseIndex
                      ),
                    }
                  : setType
              ),
            }
          : day
      )
    );
  };

  const removeSet = (dayIndex, exerciseIndex, setIndex) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) =>
      prevDays.map((day, dIndex) =>
        dIndex === dayIndex
          ? {
              ...day,
              allSetTypes: day.allSetTypes.map((setType) => ({
                ...setType,
                allExercises: setType.allExercises.map((exercise, eIndex) =>
                  eIndex === exerciseIndex
                    ? {
                        ...exercise,
                        allSets: exercise.allSets.filter(
                          (_, index) => index !== setIndex
                        ),
                      }
                    : exercise
                ),
              })),
            }
          : day
      )
    );
  };

  const handleRemoveSetType = (dayIndex, setTypeIndex) => {
    setExerciseDays((prevDays) => {
      const updatedExerciseDays = prevDays.map((day, index) => {
        if (day.day === dayIndex) {
          const updatedSetTypes = day.allSetTypes ? [...day.allSetTypes] : [];

          updatedSetTypes.splice(setTypeIndex, 1);

          return {
            ...day,
            allSetTypes: updatedSetTypes,
          };
        }

        return day;
      });

      return updatedExerciseDays;
    });
  };
  // ---------------- REMOVING ------------------

  // COPYING
  const onRepeatSet1 = (dayIndex, exerciseIndex, setIndex) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) => {
      const newDays = [...prevDays];

      const currentDay = newDays[dayIndex];
      const currentExercise = currentDay.allSetTypes.flatMap(
        (setType) => setType.allExercises
      )[exerciseIndex];

      if (setIndex > 0) {
        const currentSet = currentExercise.allSets[setIndex];
        const previousSet = currentExercise.allSets[setIndex - 1];

        const updatedSet = {
          ...currentSet,
          weight: previousSet.weight,
          selTentativeDurationHH: previousSet.selTentativeDurationHH,
          selTentativeDurationMM: previousSet.selTentativeDurationMM,
          selTentativeDurationSS: previousSet.selTentativeDurationSS,
          reps: previousSet.reps,
        };

        const updatedExercise = {
          ...currentExercise,
          allSets: currentExercise.allSets.map((set, sIndex) =>
            sIndex === setIndex ? updatedSet : set
          ),
        };

        const updatedDay = {
          ...currentDay,
          allSetTypes: currentDay.allSetTypes.map((setType) => ({
            ...setType,
            allExercises: setType.allExercises.map((exercise, eIndex) =>
              eIndex === exerciseIndex ? updatedExercise : exercise
            ),
          })),
        };

        newDays[dayIndex] = updatedDay;
      }

      return newDays;
    });
  };
  const onRepeatSet = (dayIndex, exerciseIndex, setIndex) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) => {
      const newDays = [...prevDays];
      const currentDay = newDays[dayIndex];

      const currentExercise = currentDay.allSetTypes.flatMap(
        (setType) => setType.allExercises
      )[exerciseIndex];

      if (setIndex > 0) {
        const currentSet = currentExercise.allSets[setIndex];
        const previousSet = currentExercise.allSets[setIndex - 1];

        const updatedSet = {
          ...currentSet,
          weight: previousSet.weight,
          selTentativeDurationHH: previousSet.selTentativeDurationHH,
          selTentativeDurationMM: previousSet.selTentativeDurationMM,
          selTentativeDurationSS: previousSet.selTentativeDurationSS,
          reps: previousSet.reps,
        };

        const updatedExercise = {
          ...currentExercise,
          allSets: currentExercise.allSets.map((set, sIndex) =>
            sIndex === setIndex ? updatedSet : set
          ),
        };

        const updatedDay = {
          ...currentDay,
          allSetTypes: currentDay.allSetTypes.map((setType) => ({
            ...setType,
            allExercises: setType.allExercises.map((exercise, eIndex) =>
              eIndex === exerciseIndex ? updatedExercise : exercise
            ),
          })),
        };

        newDays[dayIndex] = updatedDay;
      }

      return newDays;
    });
  };

  const copyDayValues = (sourceDayIndex, targetDayIndex) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) => {
      if (
        sourceDayIndex < 0 ||
        sourceDayIndex >= prevDays.length ||
        targetDayIndex < 0 ||
        targetDayIndex >= prevDays.length
      ) {
        console.error("Invalid day index.");
        return prevDays;
      }

      const newDays = [...prevDays];

      const sourceDay = { ...newDays[sourceDayIndex] };
      const targetDay = { ...newDays[targetDayIndex] };

      targetDay.selSetType = sourceDay.selSetType;
      targetDay.allSetTypes = sourceDay.allSetTypes.map((setType) => ({
        ...setType,
        allExercises: setType.allExercises.map((exercise) => ({
          ...exercise,
          allSets: exercise.allSets.map((set) => ({
            ...set,
          })),
        })),
      }));

      newDays[targetDayIndex] = targetDay;

      return newDays;
    });
  };

  const copyLastWeekValues = (currentDayIndex) => {
    console.log("Current Day Index:", currentDayIndex);
    setIsSubmit(false);

    setExerciseDays((prevDays) => {
      const newDays = [...prevDays];
      const numberOfDaysToCopy = 7;

      for (let i = 0; i < numberOfDaysToCopy; i++) {
        const sourceDayIndex =
          (currentDayIndex - numberOfDaysToCopy + i + prevDays.length) %
          prevDays.length;
        const targetDayIndex = currentDayIndex + i;

        if (targetDayIndex >= newDays.length) {
          console.error("Target day index out of bounds:", targetDayIndex);
          break;
        }

        const sourceDay = newDays[sourceDayIndex];
        const targetDay = newDays[targetDayIndex];

        if (!sourceDay.allSetTypes) sourceDay.allSetTypes = [];
        if (!targetDay.allSetTypes) targetDay.allSetTypes = [];

        targetDay.allSetTypes = sourceDay.allSetTypes.map((setType) => ({
          ...setType,
          allExercises: (setType.allExercises || []).map((exercise) => ({
            ...exercise,
            allSets: (exercise.allSets || []).map((set) => ({ ...set })),
          })),
        }));

        console.log(`Copied from day ${sourceDay.day} to day ${targetDay.day}`);
      }

      return newDays;
    });
  };

  const copyLastDaysValues = (currentDayIndex, daysToCopy) => {
    setIsSubmit(false);

    setExerciseDays((prevDays) => {
      const newDays = [...prevDays];
      const endIndex = currentDayIndex - 1;
      const startIndex = Math.max(endIndex - daysToCopy + 1, 0);

      if (startIndex < 0 || endIndex >= newDays.length) {
        console.error("Index out of bounds");
        return prevDays;
      }

      for (let i = startIndex; i <= endIndex; i++) {
        const sourceDayIndex = i;
        const targetDayIndex = currentDayIndex - (endIndex - i);

        if (targetDayIndex < newDays.length) {
          const sourceDay = newDays[sourceDayIndex];
          const targetDay = newDays[targetDayIndex];

          targetDay.allSetTypes = sourceDay.allSetTypes.map((setType) => ({
            ...setType,
            allExercises: setType.allExercises.map((exercise) => ({
              ...exercise,
              allSets: exercise.allSets.map((set) => ({ ...set })),
            })),
          }));
        }
      }

      return newDays;
    });
  };

  const copyLastMonthValues = (currentDayIndex) => {
    copyLastDaysValues(currentDayIndex, 30);
  };
  // --------- COPYING ---------

  // ********-------------
  // const handleSearchChange = (inputValue) => {
  //   setFetchValues((prev) => ({
  //     ...prev,
  //     page: 1,
  //     search: inputValue,
  //   }));
  // };

  // const fetchMoreData = () => {
  //   if (fetchValues.page + 1 <= totalPages) {
  //     setFetchValues((prev) => ({
  //       ...prev,
  //       page: prev.page + 1,
  //     }));
  //   }
  // };

  // const fetchPreviousData = () => {
  //   setFetchValues((prev) => ({
  //     ...prev,
  //     page: Math.max(prev.page - 1, 1),
  //   }));
  // };
  // ------------------**********

  function getWorkoutExercise(filters) {
    dispatch(
      fetchWorkoutExerciseDropdown({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getWorkoutCategory(filters) {
    dispatch(
      fetchWorkoutCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getData(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: workoutExercisesGet,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  function onClickInfo(exerciseId, name) {
    if (!exerciseId) {
      toast.error("Exercise ID Not Found!");
    } else {
      setModValues((prevs) => ({
        ...prevs,
        isModOpen: true,
        cardName: name,
        exerciseId: exerciseId,
      }));

      const filters = {
        uid: exerciseId || "",
      };

      getData(filters);
    }
  }

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  function onCloseModalvalues() {
    setModValues((prevs) => ({
      ...prevs,
      isModOpenOTHER: false,
      cardNameOTHER: "",
      rowData: "",
      viewVideo: "",
      viewImage: "",
    }));
  }

  useEffect(() => {
    getWorkoutCategory(fetchValues);
  }, [fetchValues]);

  useEffect(() => {
    if (selTempCat) {
      const sendableQPS = {
        ...fetchValues,
        category_id: selTempCat || "",
      };

      getWorkoutExercise(sendableQPS);
    }
  }, [fetchValues, selTempCat]);

  useEffect(() => {
    if (exerciseDropdownData?.pagination?.length > 0) {
      setTotalPages(exerciseDropdownData?.pagination?.[0]?.pagination || 1);
    } else {
      setTotalPages(1);
    }
  }, [exerciseDropdownData]);

  useEffect(() => {
    if (workoutCategoriesData?.pagination?.length > 0) {
      setTotalPages(workoutCategoriesData?.pagination?.[0]?.pagination || 1);
    } else {
      setTotalPages(1);
    }
  }, [workoutCategoriesData]);

  useEffect(() => {
    if (EXERCISE_DAYS_ARRAY_LENGTH > 0) {
      const plans = generatePlanDuration1(EXERCISE_DAYS_ARRAY_LENGTH);
      setWorkoutDaysDropdown(plans);
    }
  }, [EXERCISE_DAYS_ARRAY_LENGTH]);

  useEffect(() => {
    if (selectedCopyFrom?.value > 0) {
      copyDayValues(selectedCopyFrom?.value - 1, dayIndex);
    }
  }, [selectedCopyFrom]);

  useEffect(() => {
    setSelectedCopyFrom("");
  }, [dayIndex]);

  const tbColumns = [
    {
      dataField: "wo_name",
      text: "Exercise name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data bold">
            {row?.wo_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "category",
      text: "Primary muscle",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.category || "NA"}</span>;
      },
    },
    {
      dataField: "secondary_category",
      text: "Secondary muscle ",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${
              row?.secondary_category?.length > 0 ? "link" : ""
            }`}
            onClick={() =>
              row?.secondary_category?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpenOTHER: true,
                cardNameOTHER: "secondary_category",
                alternate: row.secondary_category,
              }))
            }
          >
            {row?.secondary_category?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "equipment_required",
      text: "Equipment required",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${
              row?.equipment_required?.length > 0 ? "link" : ""
            }`}
            onClick={() =>
              row?.equipment_required?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpenOTHER: true,
                cardNameOTHER: "equipment_required",
                alternate: row.equipment_required,
              }))
            }
          >
            {row?.equipment_required?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "tnv_calorie",
      text: "Tentetive calorie",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.tnv_calorie || 0}</span>;
      },
    },
    {
      dataField: "e_duration",
      text: "Tentetive Duration",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.e_duration || 0}</span>;
      },
    },
    {
      dataField: "movement_type",
      text: "movement type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.movement_type || 0}</span>;
      },
    },
    {
      dataField: "alternate",
      text: "Alternate exercise",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${row?.alternate?.length > 0 ? "link" : ""}`}
            onClick={() =>
              row?.alternate?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpenOTHER: true,
                cardNameOTHER: "alternate_exercise",
                alternate: row.alternate,
              }))
            }
          >
            {row?.alternate?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "image",
      text: "Exercise Icon",
      formatter: (cell, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.image || BodyBuilder}
              alt={row?.wo_name || "NA"}
              className="image"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpenOTHER: true,
                  viewImage: row?.image || BodyBuilder,
                  cardNameOTHER: "image",
                }))
              }
            />
          </div>
        );
      },
    },
    {
      dataField: "video",
      text: "Video",
      formatter: (cell, row) => {
        return (
          <div className="tb-play-btn">
            <button
              className="play-btn"
              type="button"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpenOTHER: row?.video ? true : false,
                  viewVideo: row?.video ? row?.video : "",
                  cardNameOTHER: "video",
                }))
              }
              style={{
                cursor: row?.video ? "pointer" : "not-allowed",
              }}
            >
              {row?.video ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-play-circle"
                  viewBox="0 0 16 16"
                  style={{ color: "rgb(52, 116, 241)" }}
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-ban"
                  viewBox="0 0 16 16"
                  style={{ color: "#787878" }}
                >
                  <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0" />
                </svg>
              )}
            </button>
          </div>
        );
      },
    },
    {
      dataField: "thumbnail",
      text: "Exercise Image",
      formatter: (cell, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.thumbnail || BodyBuilder}
              alt={row?.wo_name || "NA"}
              className="image"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpenOTHER: true,
                  viewImage: row?.thumbnail || BodyBuilder,
                  cardNameOTHER: "image",
                }))
              }
            />
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpenOTHER: true,
                rowDataEdit: row,
                cardNameOTHER: "edit",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const alternateTbColumns = [
    {
      dataField: "wo_name",
      text: "Exercise name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.wo_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "category_name",
      text: "Primary muscle",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.category_name || "NA"}</span>;
      },
    },
  ];

  const secondaryEquipmentsTbColumns = [
    {
      dataField: "name",
      text: "Name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
  ];

  // console.log("===> ", exerciseDays);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Add Exercise Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          {modValues.cardName !== "create_new_exercise" && (
            <ModalHeadAndClose
              title={`${modValues.cardName?.replace(/_/g, " ")}`}
              onClose={onCloseModal}
            />
          )}

          {modValues.cardName === "exercise_info" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              {loading ? (
                <Loader />
              ) : (
                <PaymentLinkTable
                  tableData={
                    Array.isArray(data?.data) && data.data.length > 0
                      ? data.data
                      : []
                  }
                  tableColumns={Array.isArray(tbColumns) ? tbColumns : []}
                />
              )}
            </div>
          ) : modValues.cardName === "create_new_exercise" ? (
            <ExerciseAddForm
              userInfoData={userInfoData}
              callFunction={() => {
                const sendableQPS = {
                  ...fetchValues,
                  category_id: selTempCat || "",
                };

                getWorkoutExercise(sendableQPS);
              }}
              closeModal={onCloseModal}
            />
          ) : null}
        </div>
      </Modal>

      <Modal
        isOpen={modValues.isModOpenOTHER}
        onRequestClose={onCloseModalvalues}
        contentLabel="Add Exercise Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer`}
          style={{
            width:
              modValues.cardNameOTHER === "image" ||
              modValues.cardNameOTHER === "video" ||
              modValues.cardNameOTHER === "alternate_exercise" ||
              modValues.cardNameOTHER === "secondary_category" ||
              modValues.cardNameOTHER === "equipment_required"
                ? "auto"
                : "",
            height:
              modValues.cardNameOTHER === "image" ||
              modValues.cardNameOTHER === "video"
                ? "auto"
                : "",
          }}
        >
          <ModalHeadAndClose
            title={`${modValues.cardNameOTHER?.replace(/_/g, " ")}`}
            onClose={onCloseModalvalues}
          />

          {modValues.cardNameOTHER === "alternate_exercise" ||
          modValues.cardNameOTHER === "secondary_category" ||
          modValues.cardNameOTHER === "equipment_required" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={modValues.alternate}
                tableColumns={
                  modValues.cardNameOTHER === "secondary_category" ||
                  modValues.cardNameOTHER === "equipment_required"
                    ? secondaryEquipmentsTbColumns
                    : alternateTbColumns
                }
              />
            </div>
          ) : modValues.cardNameOTHER === "image" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.viewImage}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.cardNameOTHER === "video" ? (
            <div className="discussionModalMessage mt30">
              <video width="320" height="240" controls>
                <source src={modValues.viewVideo}></source>
              </video>
            </div>
          ) : modValues.cardNameOTHER === "edit" ? (
            <ExerciseAddForm
              userInfoData={userInfoData}
              callFunction={() => {
                onClickInfo(modValues.exerciseId, "exercise_info");
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpenOTHER: false,
                  rowDataEdit: "",
                  cardNameOTHER: "",
                }));
              }}
              closeModal={onCloseModalvalues}
              isEdit={modValues.cardNameOTHER === "edit"}
              rowData={modValues.rowDataEdit}
            />
          ) : null}
        </div>
      </Modal>

      <>
        {exerciseDays?.map((day, dayIndex) => (
          <React.Fragment key={dayIndex}>
            {!isViewOnly && (
              <div className="flex-start with-tab">
                <button
                  className="more-exercise-btn"
                  type="button"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "create_new_exercise",
                    }))
                  }
                >
                  + create new exercise
                </button>

                <div className="copy-from-particular-day">
                  <div
                    className={`commonWrapper copy-from-btn ${
                      selectedCopyFrom ? "with-value" : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={workoutDaysDropdown}
                      selectedOption={selectedCopyFrom}
                      setSelectedOption={(selectedValue) =>
                        setSelectedCopyFrom(selectedValue)
                      }
                      name="Copy From Day"
                      preventKeyboardOpen={true}
                    />
                  </div>
                </div>

                {day.day > 1 && (
                  <button
                    className="copy-day-btn"
                    type="button"
                    onClick={() => copyDayValues(day.day - 2, day.day - 1)}
                  >
                    <div className="btn-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_16541_4209)">
                          <path
                            d="M18.7258 2.79841V1.93164C18.7258 1.37936 18.278 0.931641 17.7258 0.931641H1.99219C1.4399 0.931641 0.992188 1.37936 0.992188 1.93164V17.6651C0.992188 18.2174 1.4399 18.6651 1.99219 18.6651H2.85895"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M23.0078 22.0684C23.0078 22.6206 22.5601 23.0684 22.0078 23.0684H7.27734C6.72506 23.0684 6.27734 22.6206 6.27734 22.0684V7.33789C6.27734 6.78561 6.72506 6.33789 7.27734 6.33789H22.0078C22.5601 6.33789 23.0078 6.78561 23.0078 7.33789V22.0684Z"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M14.6406 18.875V10.5332"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10.4727 14.7031H18.8144"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_16541_4209">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <span className="btn-label">
                      Copy From day {day.day - 1}
                    </span>
                  </button>
                )}

                {day.day > 7 && (
                  <button
                    className="copy-day-btn"
                    type="button"
                    onClick={() => copyLastWeekValues(day.day - 1)}
                  >
                    <div className="btn-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_16541_4209)">
                          <path
                            d="M18.7258 2.79841V1.93164C18.7258 1.37936 18.278 0.931641 17.7258 0.931641H1.99219C1.4399 0.931641 0.992188 1.37936 0.992188 1.93164V17.6651C0.992188 18.2174 1.4399 18.6651 1.99219 18.6651H2.85895"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M23.0078 22.0684C23.0078 22.6206 22.5601 23.0684 22.0078 23.0684H7.27734C6.72506 23.0684 6.27734 22.6206 6.27734 22.0684V7.33789C6.27734 6.78561 6.72506 6.33789 7.27734 6.33789H22.0078C22.5601 6.33789 23.0078 6.78561 23.0078 7.33789V22.0684Z"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M14.6406 18.875V10.5332"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10.4727 14.7031H18.8144"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_16541_4209">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <span className="btn-label">
                      Copy From Day {Math.max(day.day - 7, 1)} To {day.day - 1}{" "}
                      (7 Days)
                    </span>
                  </button>
                )}

                {day.day > 30 && (
                  <button
                    className="copy-day-btn"
                    type="button"
                    onClick={() => copyLastMonthValues(day.day - 1)}
                  >
                    <div className="btn-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_16541_4209)">
                          <path
                            d="M18.7258 2.79841V1.93164C18.7258 1.37936 18.278 0.931641 17.7258 0.931641H1.99219C1.4399 0.931641 0.992188 1.37936 0.992188 1.93164V17.6651C0.992188 18.2174 1.4399 18.6651 1.99219 18.6651H2.85895"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M23.0078 22.0684C23.0078 22.6206 22.5601 23.0684 22.0078 23.0684H7.27734C6.72506 23.0684 6.27734 22.6206 6.27734 22.0684V7.33789C6.27734 6.78561 6.72506 6.33789 7.27734 6.33789H22.0078C22.5601 6.33789 23.0078 6.78561 23.0078 7.33789V22.0684Z"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M14.6406 18.875V10.5332"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10.4727 14.7031H18.8144"
                            stroke="#066CE3"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_16541_4209">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <span className="btn-label">
                      Copy From Day {Math.max(day.day - 30, 1)} To {day.day - 1}{" "}
                      (30 Days)
                    </span>
                  </button>
                )}
              </div>
            )}

            <div className="sub-form-container workout-packages">
              <div className="headinNbutton">
                <h2 className="sub-heading">Add Workout</h2>

                <div className="dayLabel">
                  <span className="label">DAY {day.day}</span>
                </div>
              </div>

              {day.allSetTypes.map((setType, setTypeIndex) => (
                <div className="sub-section">
                  <div className="formInputBox">
                    <label htmlFor={`selSetType`} className="formInputLabel">
                      Set type <span className="required">*</span>
                    </label>

                    <div className="dual-odd-input">
                      <div className="odd-long-input">
                        <div
                          className={`commonWrapper ${
                            formErrors?.exerciseDays?.[day.day - 1]
                              ?.allSetTypes?.[setTypeIndex]?.selSetType
                              ? "formError"
                              : ""
                          }`}
                        >
                          <SelectDropdown
                            options={setTypes}
                            selectedOption={setType.selSetType}
                            setSelectedOption={(selectedValue) =>
                              onChangeDropdownSetType(
                                selectedValue,
                                "selSetType",
                                day.day - 1,
                                setTypeIndex
                              )
                            }
                            name="from the list"
                            preventKeyboardOpen={false}
                            isDisable={isViewOnly}
                          />
                        </div>
                      </div>

                      {!isViewOnly && (
                        <div className="odd-short-input">
                          {
                          // setTypeIndex !== day.allSetTypes?.length - 1 
                          setTypeIndex !== 0
                          && (
                            <button
                              className="remove-set-btn"
                              type="button"
                              onClick={() =>
                                handleRemoveSetType(day.day, setTypeIndex)
                              }
                            >
                              X Remove This Set Type
                            </button>
                          )}
                          {setTypeIndex === day.allSetTypes?.length - 1 && (
                            <button
                              className="add-set-btn"
                              type="button"
                              onClick={() => handleAddSetType(day.day)}
                            >
                              + Add More Set Type
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {setType.allExercises.map((exercise, exerciseIndex) => (
                    <div className="selected-multi-box" key={exerciseIndex}>
                      <div className="flex-box">
                        <h5 className="sub-heading">
                          Exercise <span> {exercise?.exerciseId}</span>
                        </h5>

                        {!isViewOnly &&
                          ((setType.selSetType?.value !== "superset" &&
                            exerciseIndex > 0) ||
                            (setType.selSetType?.value === "superset" &&
                              setType.allExercises.length > 2 &&
                              exerciseIndex ===
                                setType.allExercises.length - 1)) && (
                            <button
                              className="remove-day-btn"
                              type="button"
                              onClick={() =>
                                removeExercise(
                                  day.day - 1,
                                  setTypeIndex,
                                  exerciseIndex
                                )
                              }
                            >
                              X Remove Exercise{" "}
                              <span> {exercise.exerciseId} </span>
                            </button>
                          )}
                      </div>

                      <div className="flex-box">
                        <div className="formInputBox">
                          <label
                            htmlFor={`selCategoryName`}
                            className="formInputLabel"
                          >
                            Exercise category{" "}
                            <span className="required">*</span>
                          </label>

                          <div
                            className={`commonWrapper ${
                              formErrors?.exerciseDays?.[day.day - 1]
                                ?.allSetTypes?.[setTypeIndex]?.allExercises?.[
                                exerciseIndex
                              ]?.selCategoryName
                                ? "formError"
                                : ""
                            }`}
                          >
                            <SelectDropdown
                              options={workoutCategoriesData?.dropdown || []}
                              selectedOption={exercise.selCategoryName}
                              setSelectedOption={(selectedValue) =>
                                onChangeDropdownExerciseName(
                                  selectedValue,
                                  "selCategoryName",
                                  day.day - 1,
                                  setTypeIndex,
                                  exerciseIndex
                                )
                              }
                              name="from the list"
                              // onSearchChange={handleSearchChange}
                              // fetchMoreData={fetchMoreData}
                              // fetchPreviousData={fetchPreviousData}
                              isDisable={isViewOnly}
                            />
                          </div>
                        </div>

                        {exercise.selCategoryName ? (
                          <div className="formInputBox">
                            <div className="tab-label-icon">
                              <label
                                htmlFor={`selExerciseName`}
                                className="formInputLabel"
                              >
                                Exercise name{" "}
                                <span className="required">*</span>{" "}
                              </label>
                              {exercise.selExerciseName ? (
                                <span
                                  className="info-icon"
                                  onClick={() =>
                                    onClickInfo(
                                      exercise.selExerciseName?.value,
                                      "exercise_info"
                                    )
                                  }
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-info-circle-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                                  </svg>
                                  View Exercise Info
                                </span>
                              ) : null}
                            </div>

                            <div
                              className={`commonWrapper ${
                                formErrors?.exerciseDays?.[day.day - 1]
                                  ?.allSetTypes?.[setTypeIndex]?.allExercises?.[
                                  exerciseIndex
                                ]?.selExerciseName
                                  ? "formError"
                                  : ""
                              }`}
                            >
                              <SelectDropdown
                                options={exerciseDropdownData?.dropdown || []}
                                selectedOption={exercise.selExerciseName}
                                setSelectedOption={(selectedValue) =>
                                  onChangeDropdownExerciseName(
                                    selectedValue,
                                    "selExerciseName",
                                    day.day - 1,
                                    setTypeIndex,
                                    exerciseIndex
                                  )
                                }
                                name="from the list"
                                // onSearchChange={handleSearchChange}
                                // fetchMoreData={fetchMoreData}
                                // fetchPreviousData={fetchPreviousData}
                                isDisable={isViewOnly}
                              />
                            </div>
                          </div>
                        ) : null}

                        <div className="formInputBox">
                          <label
                            htmlFor={`restTime`}
                            className="formInputLabel"
                          >
                            Rest time <span className="required">*</span>
                          </label>
                          <div
                            className={`commonWrapper ${
                              formErrors?.exerciseDays?.[day.day - 1]
                                ?.allSetTypes?.[setTypeIndex]?.allExercises?.[
                                exerciseIndex
                              ]?.restTime
                                ? "formError"
                                : ""
                            }`}
                          >
                            <input
                              type="number"
                              placeholder="Rest time in seconds"
                              className={`formInput ${
                                formErrors?.restTime ? "formError" : ""
                              }`}
                              name="restTime"
                              value={exercise.restTime}
                              onChange={(e) =>
                                onChangeExerciseInput(
                                  e,
                                  day.day - 1,
                                  setTypeIndex,
                                  exerciseIndex
                                )
                              }
                              min={0}
                              disabled={isViewOnly}
                            />
                          </div>
                        </div>

                        <div className="formInputBox">
                          <label
                            htmlFor={`sequenceNo`}
                            className="formInputLabel"
                          >
                            sequence number <span className="required">*</span>
                          </label>
                          <div
                            className={`commonWrapper ${
                              formErrors?.exerciseDays?.[day.day - 1]
                                ?.allSetTypes?.[setTypeIndex]?.allExercises?.[
                                exerciseIndex
                              ]?.sequenceNo
                                ? "formError"
                                : ""
                            }`}
                          >
                            <input
                              type="number"
                              placeholder="Enter sequence number"
                              className={`formInput ${
                                formErrors?.sequenceNo ? "formError" : ""
                              }`}
                              name="sequenceNo"
                              value={exercise.sequenceNo}
                              onChange={(e) =>
                                onChangeExerciseInput(
                                  e,
                                  day.day - 1,
                                  setTypeIndex,
                                  exerciseIndex
                                )
                              }
                              min={1}
                              disabled={isViewOnly}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="selected-multi-box">
                        {exercise.allSets.map((set, setIndex) => {
                          return (
                            <div className="flex-box" key={setIndex}>
                              {exercise.selExerciseName?.info?.workout_mode ===
                              "time_based" ? (
                                <div className="formInputBox longOne">
                                  <label
                                    htmlFor={`selTentativeDurationSS`}
                                    className="formInputLabel"
                                  >
                                    Time <span className="required">*</span>
                                  </label>

                                  <div className="three-input-container">
                                    <div
                                      className={`commonWrapper inputs ${
                                        formErrors?.exerciseDays?.[day.day - 1]
                                          ?.allSetTypes?.[setTypeIndex]
                                          ?.allExercises?.[exerciseIndex]
                                          ?.allSets?.[setIndex]
                                          ?.selTentativeDurationHH
                                          ? "formError"
                                          : ""
                                      }`}
                                    >
                                      <div className="first-child">
                                        <SelectDropdownLabel
                                          options={HHMMSS}
                                          selectedOption={
                                            set.selTentativeDurationHH
                                          }
                                          setSelectedOption={(selectedValue) =>
                                            onChangeDuration(
                                              selectedValue,
                                              "selTentativeDurationHH",
                                              day.day - 1,
                                              exerciseIndex,
                                              setIndex,
                                              setTypeIndex
                                            )
                                          }
                                          name="HH"
                                          preventKeyboardOpen={true}
                                          isDisable={isViewOnly}
                                        />
                                      </div>

                                      <div className="grayInputLine"></div>
                                      <span className="value">HH</span>
                                    </div>

                                    <div
                                      className={`commonWrapper inputs ${
                                        formErrors?.exerciseDays?.[day.day - 1]
                                          ?.allSetTypes?.[setTypeIndex]
                                          ?.allExercises?.[exerciseIndex]
                                          ?.allSets?.[setIndex]
                                          ?.selTentativeDurationMM
                                          ? "formError"
                                          : ""
                                      }`}
                                    >
                                      <div className="first-child">
                                        <SelectDropdownLabel
                                          options={HHMMSS}
                                          selectedOption={
                                            set.selTentativeDurationMM
                                          }
                                          setSelectedOption={(selectedValue) =>
                                            onChangeDuration(
                                              selectedValue,
                                              "selTentativeDurationMM",
                                              day.day - 1,
                                              exerciseIndex,
                                              setIndex,
                                              setTypeIndex
                                            )
                                          }
                                          name="MM"
                                          preventKeyboardOpen={true}
                                          isDisable={isViewOnly}
                                        />
                                      </div>
                                      <div className="grayInputLine"></div>
                                      <span className="value">MM</span>
                                    </div>

                                    <div
                                      className={`commonWrapper inputs ${
                                        formErrors?.exerciseDays?.[day.day - 1]
                                          ?.allSetTypes?.[setTypeIndex]
                                          ?.allExercises?.[exerciseIndex]
                                          ?.allSets?.[setIndex]
                                          ?.selTentativeDurationSS
                                          ? "formError"
                                          : ""
                                      }`}
                                    >
                                      <div className="first-child">
                                        <SelectDropdownLabel
                                          options={HHMMSS}
                                          selectedOption={
                                            set.selTentativeDurationSS
                                          }
                                          setSelectedOption={(selectedValue) =>
                                            onChangeDuration(
                                              selectedValue,
                                              "selTentativeDurationSS",
                                              day.day - 1,
                                              exerciseIndex,
                                              setIndex,
                                              setTypeIndex
                                            )
                                          }
                                          name="SS"
                                          preventKeyboardOpen={true}
                                          isDisable={isViewOnly}
                                        />
                                      </div>
                                      <div className="grayInputLine"></div>
                                      <span className="value">SS</span>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="formInputBox longOne">
                                  <label
                                    htmlFor={`weight`}
                                    className="formInputLabel"
                                  >
                                    Weight <span className="required">*</span>
                                  </label>
                                  <div
                                    className={`commonWrapper inputs ${
                                      formErrors?.exerciseDays?.[day.day - 1]
                                        ?.allSetTypes?.[setTypeIndex]
                                        ?.allExercises?.[exerciseIndex]
                                        ?.allSets?.[setIndex]?.weight
                                        ? "formError"
                                        : ""
                                    }`}
                                  >
                                    <input
                                      type="number"
                                      placeholder="Enter Weight"
                                      className={`formInput ${
                                        formErrors?.weight ? "formError" : ""
                                      }`}
                                      name="weight"
                                      value={set.weight}
                                      onChange={(e) =>
                                        onChangeInput(
                                          e,
                                          day.day - 1,
                                          exerciseIndex,
                                          setIndex
                                        )
                                      }
                                      min={0}
                                      disabled={isViewOnly}
                                    />

                                    <div className="grayInputLine"></div>

                                    <span className="value">Kg</span>
                                  </div>
                                </div>
                              )}

                              <div className="formInputBox shortOne">
                                <label
                                  htmlFor={`reps`}
                                  className="formInputLabel"
                                >
                                  Reps{" "}
                                  {exercise.selCategoryName?.label?.toLowerCase() !==
                                  "cardio" ? (
                                    <span className="required">*</span>
                                  ) : null}
                                </label>
                                <div
                                  className={`commonWrapper inputs ${
                                    formErrors?.exerciseDays?.[day.day - 1]
                                      ?.allSetTypes?.[setTypeIndex]
                                      ?.allExercises?.[exerciseIndex]
                                      ?.allSets?.[setIndex]?.reps
                                      ? "formError"
                                      : ""
                                  }`}
                                >
                                  <input
                                    type="number"
                                    placeholder="Enter number"
                                    className={`formInput ${
                                      formErrors?.reps ? "formError" : ""
                                    }`}
                                    name="reps"
                                    value={set.reps}
                                    onChange={(e) =>
                                      onChangeInput(
                                        e,
                                        day.day - 1,
                                        exerciseIndex,
                                        setIndex
                                      )
                                    }
                                    min={0}
                                    disabled={isViewOnly}
                                  />
                                </div>
                              </div>

                              {!isViewOnly && setIndex > 0 && (
                                <div className="copy-feature">
                                  <div className="flex-start">
                                    <button
                                      className="repeat-btn"
                                      type="button"
                                      onClick={() =>
                                        onRepeatSet(
                                          day.day - 1,
                                          exerciseIndex,
                                          setIndex
                                        )
                                      }
                                    >
                                      <div className="icon">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <path
                                            d="M18.1716 6.99858H11C7.68629 6.99858 5 9.68487 5 12.9986C5 16.3123 7.68629 18.9986 11 18.9986H20V20.9986H11C6.58172 20.9986 3 17.4168 3 12.9986C3 8.5803 6.58172 4.99858 11 4.99858H18.1716L15.636 2.46305L17.0503 1.04883L22 5.99858L17.0503 10.9483L15.636 9.53412L18.1716 6.99858Z"
                                            fill="black"
                                          />
                                        </svg>
                                      </div>
                                      <span className="copy-label">Repeat</span>
                                    </button>
                                  </div>

                                  <button
                                    className="remove-day-btn"
                                    type="button"
                                    onClick={() =>
                                      removeSet(
                                        day.day - 1,
                                        exerciseIndex,
                                        setIndex
                                      )
                                    }
                                  >
                                    X Remove Set {setIndex + 1}
                                  </button>
                                </div>
                              )}
                            </div>
                          );
                        })}

                        {!isViewOnly && (
                          <div className="flex-box flex-start">
                            <button
                              className="more-sets-btn"
                              type="button"
                              onClick={() =>
                                addMoreSet(day.day - 1, exerciseIndex)
                              }
                            >
                              + Add more set
                            </button>

                            {exerciseIndex ===
                              setType.allExercises?.length - 1 && (
                              <button
                                className="more-exercise-btn"
                                type="button"
                                onClick={() =>
                                  addNewExercise(day.day - 1, setTypeIndex)
                                }
                              >
                                + Add exercise
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </React.Fragment>
        ))}
      </>
    </>
  );
};

export default WorkoutDays;
